import { h, Component, createRef } from 'preact';
import { observer } from 'mobx-preact';

import MarkdownDisplay from '../../components/gui/markdownDisplay';
import localUtil from '../../lib/util';

@observer
class FactBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            isOverflowing: false,
        };
        this.contentRef = createRef();
    }

    loadAll = async () => {
        const { articleId, stores } = this.props;
        const { articleStore } = stores;
        if (articleId) {
            await articleStore.loadFactboxArticle(articleId);
        }
    }

    checkOverflow = () => {
        if (this.contentRef.current) {
            const el = this.contentRef.current;
            const isOverflowing = el.scrollHeight > el.clientHeight;
            if (isOverflowing !== this.state.isOverflowing) {
                this.setState({ isOverflowing });
            }
        }
    }

    toggleExpanded = () => {
        this.setState(prev => ({ expanded: !prev.expanded }));
    }

    componentDidMount() {
        this.loadAll();
        // Check overflow after content loads
        setTimeout(() => this.checkOverflow(), 500);
    }

    componentDidUpdate() {
        this.checkOverflow();
    }

    render() {
        const { articleId, stores } = this.props;
        const { expanded, isOverflowing } = this.state;
        const { articleStore } = stores;

        const factboxArticles = articleStore.factboxArticles || {};
        const factbox = factboxArticles[articleId];

        if (!factbox) {
            return null;
        }

        const maxHeight = expanded ? 'none' : '300px';

        return (
            <div class='my-4 p-3 rounded-3 bg-body-secondary border-start border-4 border-info'>
                {factbox.title && (
                    <div class='fw-bold mb-2' style='font-size: 1.1em;'>
                        <i class='fa-solid fa-lightbulb me-2 text-info' />
                        {factbox.title}
                    </div>
                )}
                <div
                    ref={this.contentRef}
                    style={`overflow: hidden; max-height: ${maxHeight}; position: relative;`}
                >
                    <MarkdownDisplay
                        markdown={factbox.body || ''}
                        markedOpts={localUtil.getMarkdownOptions()}
                        stores={stores}
                    />
                    {!expanded && isOverflowing && (
                        <div
                            class='position-absolute w-100'
                            style='bottom: 0; left: 0; height: 60px; background: linear-gradient(transparent, var(--bs-secondary-bg));'
                        />
                    )}
                </div>
                {(expanded || !isOverflowing) && factbox.factSource && (
                    <div class='fst-italic text-body-secondary small mt-2'>
                        Kilde: {factbox.factSource}
                    </div>
                )}
                {isOverflowing && (
                    <button
                        type='button'
                        class='btn btn-sm btn-link p-0 mt-2'
                        onClick={this.toggleExpanded}
                    >
                        {expanded ? 'Vis mindre' : 'Vis mer'}
                    </button>
                )}
            </div>
        );
    }
}

export default FactBox;
